import { IdentifiableData, ISelectableData } from '@shared/models/generictablecolumn';
import { SelectManager } from './SelectManager';
import { actionDefintion, actionInfo } from './SimpleActionManager';

export class SelectActionManager<T extends IdentifiableData> {
	public currentVisibleActions: actionInfo<T>[] = [];
	currentActions: Array<{
		enableCounter?: number; // new: counts how many items are selected
		disableCounter?: number; // new: counts how many items are selected to disable the
		definition: actionDefintion<T>;
	}> = [];

	actions: actionDefintion<T>[] = [];
	selectManager: SelectManager<T>;

	setActions(actions: actionDefintion<T>[]) {
		this.actions = actions;

		this.resetVisibleSelectActions();
	}

	setSelectManager(selectManager: SelectManager<T>) {
		this.selectManager = selectManager;

		selectManager.selectedEvent.subscribe((item: T) => {
			this.handleSelect(item, true);
		});

		selectManager.unSelectedEvent.subscribe((item: T) => {
			this.handleSelect(item, false);
		});

		selectManager.dataChanged.subscribe(() => {
			this.resetVisibleSelectActions();
		});
	}

	handleSelect(item: ISelectableData<any>, selected: boolean) {
		this.currentActions.forEach((action) => {
			if (action.definition.filter && action.definition.filter(item)) {
				if (selected) action.enableCounter++;
				else action.enableCounter--;
			}

			if (action.definition.disableFilter && action.definition.disableFilter(item)) {
				if (selected) action.disableCounter++;
				else action.disableCounter--;
			}
		});
	}

	prepareVisibleActions() {
		this.currentVisibleActions = this.currentActions.map((action) => {
			const actionInfo = {
				definition: action.definition, // action definition
				disabled: false, // initially all actions are enabled
				message: undefined as string | undefined, // message to show when action is disabled
			};

			// Include actions that can be enabled
			if (action.definition.filter && action.enableCounter === 0) {
				actionInfo.disabled = true; // only include actions that can be enabled
				actionInfo.message = action.definition.filterMessage; // message to show when filter is applied
			}

			// skip actions that should be disabled
			if (action.definition.disableFilter && action.disableCounter > 0) {
				actionInfo.disabled = true; // skip actions that should be disabled
				actionInfo.message = action.definition.filterDisableMessage; // message to show when filter is disabled
			}

			return actionInfo;
		});
	}

	resetVisibleSelectActions() {
		this.currentActions = this.actions.map((action) => ({
			enableCounter: 0, // new: counts how many items are selected
			disableCounter: 0, // new: counts how many items are selected to disable the
			definition: action,
		}));

		this.currentVisibleActions = this.actions.map((action) => {
			return {
				definition: action,
				disabled: action.filter === undefined, // initially all actions are disabled
			};
		});
	}
}
